import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { medicoConstants } from '../types/medicos.types';
import { Medico } from '../types/medico.types';
 
const entityConstants = medicoConstants
 
const fetchMedicos = async (id?: number): Promise<Medico[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}${id ? `${id}/` : ''}`);
	return response?.data?.medicos;
};

const fetchMyProfile = async (): Promise<Medico[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}myProfile`);
	return [response?.data] as Medico[];
};

export const useMedicos = () => {
	return useQuery<Medico[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => fetchMedicos(),
		// staleTime: 5 * 60 * 1000,
		enabled: true,
	});
};

export const useMedico = (id?: number) => {
	return useQuery<Medico[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => id ? fetchMedicos(id) : fetchMyProfile(),
		// staleTime: 5 * 60 * 1000,
	});
};

export interface DisponibilidadHoras {
	hora: string,
}
export interface DisponibilidadFechas {
	fecha: string,
	horarios: string[],
}

export interface OpcionesTurnos {
	dni: number,
	nombre: string,
	apellido: string,
	nombreCompleto: string,
	email: string,
	telefono: string,
	matricula: string,
	tarifa: number,
	disponibilidades: DisponibilidadFechas[],
}

// const fetchOpcionesTurnos = async (especialidadId: number): Promise<any[]> => {
const fetchOpcionesTurnos = async (especialidadId: number): Promise<OpcionesTurnos[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}disponibles/espec/${especialidadId}`);
	return response?.data?.medicos;
};


export const useOpcionesTurnos = (especialidadId?: number) => {
	return useQuery<OpcionesTurnos[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => fetchOpcionesTurnos(especialidadId || 0),
		enabled: especialidadId !== undefined,
	});
};
